const API_BASE_URL = process.env.NODE_ENV === 'development'
  ? 'http://localhost:5000'
  : 'https://jog-backend.onrender.com';

const saveToDatabase = async (responses, personalInfo, version = 'founder', partner = 'default') => {
  try {
    // Sort responses by question ID (e.g., Q1, Q2, ...)
    const sortedResponseValues = Object.entries(responses)
      .sort(([a], [b]) => {
        const aNum = parseInt(a.match(/\d+/)?.[0], 10);
        const bNum = parseInt(b.match(/\d+/)?.[0], 10);
        return aNum - bNum;
      })
      .map(([, value]) => value);

    // Build final flat array based on version
    // If jobTitle is "Other", use the specified jobTitleOther value
    const jobTitle = personalInfo.jobTitle === 'Other' && personalInfo.jobTitleOther
      ? personalInfo.jobTitleOther
      : personalInfo.jobTitle;

    // If fundingStage is "Other", use the specified fundingStageOther value  
    const fundingStage = personalInfo.fundingStage === 'Other' && personalInfo.fundingStageOther
      ? personalInfo.fundingStageOther
      : personalInfo.fundingStage;

    let finalPayload;
    if (version === 'founder') {
      // For founder version: [name, company, fundingStage, email, jobTitle, ...answers]
      // Pad with empty values if co-founder questions weren't answered (to maintain consistent column count)
      const paddedResponses = [...sortedResponseValues];
      
      // If not a co-founder (49 responses), add 7 empty values for the missing co-founder questions
      if (sortedResponseValues.length === 49 && 
          personalInfo.jobTitle !== 'Co-Founder' && 
          personalInfo.jobTitle !== 'Founder (With a Co-Founder)') {
        paddedResponses.push('', '', '', '', '', '', '');
      }
      
      finalPayload = [
        personalInfo.name,
        personalInfo.company,
        fundingStage || '',
        personalInfo.email,
        jobTitle,
        ...paddedResponses
      ];
    } else {
      // For other versions: [name, company, jobTitle, email, ...answers]
      finalPayload = [
        personalInfo.name,
        personalInfo.company,
        jobTitle,
        personalInfo.email,
        ...sortedResponseValues
      ];
    }

    // Decide sheet name based on version
    const sheetName = version === 'marketing' 
      ? 'marketing'
      : version === 'founder'
      ? 'founder' 
      : (personalInfo.jobTitle && personalInfo.jobTitle.toLowerCase() === 'founder' ? 'founder' : 'cmo');

    console.log('Submitting to backend:', { 
      sheetName, 
      finalPayloadLength: finalPayload.length, 
      finalPayload,
      jobTitle: personalInfo.jobTitle,
      version: version,
      responseCount: sortedResponseValues.length
    });

    const dbResponse = await fetch(`${API_BASE_URL}/api/save_to_db`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sheet: sheetName,
        responses: finalPayload,
        partner: partner
      })
    });

    console.log('Backend response status:', dbResponse.status);

    if (dbResponse.ok) {
      // Determine the number of relationships based on job title
      const relationshipCount = version === 'founder' && 
        (personalInfo.jobTitle === 'Co-Founder' || personalInfo.jobTitle === 'Founder (With a Co-Founder)') 
        ? '8' : '7';
      
      // Determine the benchmark comparison text based on version
      const benchmarkComparison = version === 'founder' 
        ? 'other founders' 
        : 'marketing leaders in similar roles';
      
      // Debug logging for email payload
      const emailPayload = {
        email: personalInfo.email,
        name: personalInfo.name,
        company: personalInfo.company,
        jobTitle: jobTitle,
        relationshipCount: relationshipCount,
        benchmarkComparison: benchmarkComparison,
        version: version,
        partner: partner
      };
      console.log('Sending email with payload:', emailPayload);
      
      // Send confirmation email (fire and forget)
      fetch(`${API_BASE_URL}/api/send_confirmation_email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(emailPayload)
      }).then(r => {
        if (!r.ok) throw new Error('Email failed');
        return r.json();
      }).then(data => {
        console.log('Confirmation email sent:', data);
      }).catch(e => {
        console.error('Confirmation email error:', e);
      });
      alert('✅ Response saved to database.');
    } else {
      const error = await dbResponse.json();
      console.error('Backend error:', error);
      alert('❌ Failed to save response to DB.');
    }
  } catch (error) {
    console.error('Save to DB failed:', error);
    alert('❌ DB save failed. Check console for details.');
  }
};

export default saveToDatabase;
